import React, { useEffect, useState } from "react";
import {
  Input,
  DatePicker,
  Row,
  Col,
  Form,
  Select,
  Upload,
  message,
  Button,
  Modal,
  Tooltip,
} from "antd";
import { useForm } from "antd/es/form/Form";
import DocumentBox from "../../../components/common/DocumentBox";
import { EditFilled, UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import API_MANAGER from "../../../API";
import { s3PreUrl } from "../../../constants";
import axios from "axios";

function OtherDetailEdit({
  data,
  handleOtherDetailEdit,
  otherDetailEdit,
  citizen,
  classData,
  conditions,
  userId,
  stateTags,
  
}) {
  const [fileList, setFileList] = useState([]);
  const [fileListBack, setFileListBack] = useState([]);
  const [visaTypeData, setVisaTypeData] = useState([]);
  const [countries, setCountries] = useState([]);
  const [otherDetailForm] = useForm();
  const [editDocument, setEditDocument] = useState(false);
  const [editBackDocument, setEditBackDocument] = useState(false);
  const [documentDeleted, setDocumentDeleted] = useState(false);
  const [documentBackDeleted, setDocumentBackDeleted] = useState(false);
  const props = {
    name: "file",
    accept: "image/jpg,image/jpeg,.pdf",
    multiple: false,
    customRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  const getVisaTypes = async () => {
    try {
      const response = await API_MANAGER.getPickListTags({
        type: "VISA",
        limit: 2000,
        sort: "name",
      });
      console.log("Visa types response:", response);
      const apiData = response?.data?.data?.tags || [];
      setVisaTypeData(apiData.length > 0 ? apiData : [{ _id: "1", name: "Tourist Visa" }, { _id: "2", name: "Work Visa" }, { _id: "3", name: "Student Visa" }]);
      console.log("Visa types data:", response?.data?.data?.tags);
    } catch (error) {
      console.error("Error fetching visa types:", error);
    }
  };

  const getCountries = async () => {
    try {
      const response = await API_MANAGER.getPickListTags({
        type: "COUNTRY",
        limit: 2000,
        sort: "name",
      });
      setCountries(response?.data?.data?.tags || []);
    } catch (error) {
      message.error("Something went wrong while fetching countries");
    }
  };
  const handleUpload = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    setDocumentDeleted(false); // Reset delete flag if new file is uploaded
  };
  const handleBackUpload = ({ fileList: newFileList }) => {
    setFileListBack(newFileList);
    setDocumentBackDeleted(false); // Reset delete flag if new file is uploaded
  };

  const handleDeleteDocument = () => {
    Modal.confirm({
      title: "Delete Document",
      content: "Are you sure you want to delete this document?",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        setDocumentDeleted(true);
        setEditDocument(false);
        setFileList([]);
        message.success("Document marked for deletion. Click Update to save changes.");
      },
    });
  };

  const handleDeleteBackDocument = () => {
    Modal.confirm({
      title: "Delete Back Document",
      content: "Are you sure you want to delete the back document?",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        setDocumentBackDeleted(true);
        setEditBackDocument(false);
        setFileListBack([]);
        message.success("Back document marked for deletion. Click Update to save changes.");
      },
    });
  };
  const isValidDate = (dateValue) => {
    if (!dateValue) return false;
    const date = dayjs(dateValue);
    if (!date.isValid()) return false;
    // Check if date is epoch date (01 Jan 1970)
    const epochDate = dayjs("1970-01-01");
    return !date.isSame(epochDate, 'day');
  };

  const setFields = () => {
    let visaTypeNo = "";
    let grantNo = "";
    let passportNumber = "";
    let nationality = "";
    let licenseNumber = "";
    let stateDL = "";
    let idNumber = "";
    let state = "";
    let expiry = null;
    let expiryDate = null;
    let driverClass = null;
    let driverConditions = null;

    if (data?.documentType?.name === "VISA") {
      visaTypeNo = data?.documentData?.visaTypeNo?.id;
      grantNo = data?.documentData?.grantNo;
      expiryDate = isValidDate(data?.documentData?.expiryDate)
        ? dayjs(data?.documentData?.expiryDate)
        : null;
    }
    if (data.documentType.name === "Passport") {
      passportNumber = data.documentData.passportNumber;
      nationality = data.documentData.nationality;
      expiryDate = isValidDate(data.documentData.expiryDate)
        ? dayjs(data.documentData.expiryDate)
        : isValidDate(data.documentData.expiry)
        ? dayjs(data.documentData.expiry)
        : null;
    }
    if (data.documentType.name === "Driver Licence") {
      licenseNumber = data.documentData.licenseNumber
        ? data.documentData.licenseNumber
        : data.documentData.licenceNumber;
      stateDL = data.documentData.state || data.documentData.stateDL;
      // Get all values from class and conditions arrays if they exist
      // Map IDs to names using classData and conditions arrays
      if (data.documentData.class && data.documentData.class.length > 0) {
        const classArray = Array.isArray(data.documentData.class) ? data.documentData.class : [data.documentData.class];
        driverClass = classArray.map(item => {
          // If it's an object, extract name or _id
          if (typeof item === 'object' && item !== null) {
            const itemId = item._id || item.id;
            const itemName = item.name;
            // If we have a name, use it directly
            if (itemName) {
              return itemName;
            }
            // Otherwise, find the name from classData using the ID
            if (itemId && classData) {
              const foundClass = classData.find(c => c._id === itemId || c.id === itemId);
              return foundClass?.name || itemId;
            }
            return itemId || item;
          }
          // If it's a string/number, check if it's an ID and map to name
          if (classData) {
            const foundClass = classData.find(c => c._id === item || c.id === item || c.name === item);
            return foundClass?.name || item;
          }
          return item;
        });
      } else {
        driverClass = [];
      }
      
      if (data.documentData.conditions && data.documentData.conditions.length > 0) {
        const conditionsArray = Array.isArray(data.documentData.conditions) ? data.documentData.conditions : [data.documentData.conditions];
        driverConditions = conditionsArray.map(item => {
          // If it's an object, extract name or _id
          if (typeof item === 'object' && item !== null) {
            const itemId = item._id || item.id;
            const itemName = item.name;
            // If we have a name, use it directly
            if (itemName) {
              return itemName;
            }
            // Otherwise, find the name from conditions using the ID
            if (itemId && conditions) {
              const foundCondition = conditions.find(c => c._id === itemId || c.id === itemId);
              return foundCondition?.name || itemId;
            }
            return itemId || item;
          }
          // If it's a string/number, check if it's an ID and map to name
          if (conditions) {
            const foundCondition = conditions.find(c => c._id === item || c.id === item || c.name === item);
            return foundCondition?.name || item;
          }
          return item;
        });
      } else {
        driverConditions = [];
      }
      expiryDate = isValidDate(data.documentData.expiryDate)
        ? dayjs(data.documentData.expiryDate)
        : isValidDate(data.documentData.expiry)
        ? dayjs(data.documentData.expiry)
        : null;
    }
    if (data.documentType.name === "Proof of Age/Photo Card") {
      idNumber = data.documentData.idNumber;
      state = data.documentData.state;
      expiryDate = isValidDate(data.documentData.expiryDate)
        ? dayjs(data.documentData.expiryDate)
        : isValidDate(data.documentData.expiry)
        ? dayjs(data.documentData.expiry)
        : null;
    }

    otherDetailForm.setFieldsValue({
      citizen: citizen,
      visaTypeNo: visaTypeNo,
      grantNo: grantNo,
      passportNumber: passportNumber,
      nationality: nationality,
      licenseNumber: licenseNumber,
      stateDL: stateDL,
      class: driverClass,
      conditions: driverConditions,
      idNumber: idNumber,
      state: state,
      issueDate: data.documentData.issueDate
        ? dayjs(data.documentData.issueDate)
        : null,
      expiry: expiry,
      expiryDate: expiryDate,
      documentBack: data?.documentBack,
    });
  };
  const handleFinish = async (values) => {
    try {
      // Validate document upload - document is mandatory
      const hasExistingDocument = data?.document && !documentDeleted;
      const hasNewDocument = fileList?.length > 0 && fileList[0]?.originFileObj;
      
      if (!hasExistingDocument && !hasNewDocument) {
        message.error("Please upload a document");
        return;
      }
      
      if (documentDeleted && !hasNewDocument) {
        message.error("Please upload a new document before deleting the existing one");
        return;
      }
      
      // Ensure class and conditions are arrays
      values.class = Array.isArray(values.class) ? values.class : (values.class ? [values.class] : []);
      values.conditions = Array.isArray(values.conditions) ? values.conditions : (values.conditions ? [values.conditions] : []);
      let documentUrl = data?.document;
      
      // Handle document deletion
      if (documentDeleted) {
        documentUrl = ""; // Set empty string to delete document
      } else if (fileList?.length > 0 && fileList[0]?.originFileObj) {
        const dataDocument = {
          extension: fileList[0]?.type.split("/")[1],
          type: "DOCUMENT",
          name: fileList[0].originFileObj.name,
          contentType: fileList[0]?.type,
        };
        const responseDocument = await API_MANAGER.fileUpload(dataDocument);
        if (!responseDocument?.data?.data?.url) {
          throw new Error("Failed to get upload URL for document");
        }
        await axios.put(
          responseDocument?.data?.data?.url,
          fileList[0]?.originFileObj
        );
        documentUrl = s3PreUrl + responseDocument.data?.data?.key;
      }
      
      values.document = documentUrl;
      
      //Upload Back Doc (only for VISA, Driver Licence, and Proof of Age/Photo Card)
      if (data?.documentType?.name === "VISA" || data?.documentType?.name === "Driver Licence" || data?.documentType?.name === "Proof of Age/Photo Card") {
        let documentBackUrl = data?.documentBack;
        
        if (documentBackDeleted) {
          documentBackUrl = ""; // Set empty string to delete back document
        } else if (fileListBack?.length > 0 && fileListBack[0]?.originFileObj) {
          const dataBackDocument = {
            extension: fileListBack[0]?.type.split("/")[1],
            type: "DOCUMENT",
            name: fileListBack[0].originFileObj.name,
            contentType: fileListBack[0]?.type,
          };
          const responseBackDocument = await API_MANAGER.fileUpload(dataBackDocument);
          if (!responseBackDocument?.data?.data?.url) {
            throw new Error("Failed to get upload URL for back document");
          }
          await axios.put(
            responseBackDocument?.data?.data?.url,
            fileListBack[0]?.originFileObj
          );
          documentBackUrl = s3PreUrl + responseBackDocument.data?.data?.key;
        }
        
        values.documentBack = documentBackUrl;
      }
      
      if (!data?._id) {
        throw new Error("Document ID not found");
      }
      
      // Transform documentData for Driver Licence: rename stateDL to state
      let documentDataPayload = { ...values };
      if (data?.documentType?.name === "Driver Licence" && values.stateDL) {
        documentDataPayload.state = values.stateDL;
        delete documentDataPayload.stateDL;
      }
      
      const objData = {
        userId: userId,
        document: values?.document,
        documentBack: (data?.documentType?.name === "VISA" || data?.documentType?.name === "Driver Licence" || data?.documentType?.name === "Proof of Age/Photo Card") ? values?.documentBack : undefined,
        documentData: documentDataPayload,
      };
      values.userId = userId;
      await API_MANAGER.editCandidateDocument(objData, data._id);
      message.success("Successfully edited documents");
      setDocumentDeleted(false);
      setDocumentBackDeleted(false);
      handleOtherDetailEdit();
    } catch (error) {
      console.error("Document upload error:", error);
      const errorMessage = error?.response?.data?.message?.message 
        || error?.message 
        || "Failed to upload document. Please try again.";
      message.error(errorMessage);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Form validation failed:', errorInfo);
    console.log('Error fields:', errorInfo.errorFields);
    // The validation messages will automatically appear below the fields
    // No API call will be made
    message.error('Please fill in all mandatory fields');
  };

  useEffect(() => {
    if (otherDetailEdit && data) {
      setFields();
      setDocumentDeleted(false); // Reset delete state when data changes
      setDocumentBackDeleted(false); // Reset delete state
      setEditDocument(false); // Reset edit state
      setEditBackDocument(false); // Reset edit state
      setFileList([]); // Reset file list
      setFileListBack([]); // Reset back file list
    }
  }, [otherDetailEdit, data]);
  useEffect(() => {
    getVisaTypes();
    getCountries();
  }, []);

 
  return (
    <>
      <Modal
        centered
        footer={false}
        open={otherDetailEdit}
        title={"Other Detail Edit"}
        className="resumeModal"
        onCancel={() => {
          handleOtherDetailEdit(false);
          setDocumentDeleted(false);
          setDocumentBackDeleted(false);
          setEditDocument(false);
          setEditBackDocument(false);
          setFileList([]);
          setFileListBack([]);
        }}
      >
        <Form 
          form={otherDetailForm} 
          layout="vertical" 
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          validateTrigger="onSubmit"
        >
          <Row>
            <Col xs={24}>
              <Row>
                <Col>
                  <p className="title">{data?.documentType?.name}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={18}>
                  {editDocument || documentDeleted || !data?.document ? (
                    <Upload {...props} onChange={(e) => handleUpload(e)}>
                      <Button icon={<UploadOutlined />}>Upload {documentDeleted ? "New" : ""} Document</Button>
                    </Upload>
                  ) : (
                    <DocumentBox date={data?.createdAt} url={data?.document} />
                  )}
                  {documentDeleted && (
                    <div style={{ padding: "10px 0", color: "#ff4d4f", fontSize: "12px" }}>
                      <p>Previous document will be deleted. Upload a new document or click Update to confirm deletion.</p>
                    </div>
                  )}
                </Col>
                <Col className="editResume" xs={6}>
                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    {!editDocument && !documentDeleted && data?.document && (
                      <>
                        <Tooltip title="Delete document">
                          <DeleteOutlined 
                            onClick={handleDeleteDocument}
                            style={{ 
                              color: "#ff4d4f", 
                              fontSize: "18px", 
                              cursor: "pointer" 
                            }}
                          />
                        </Tooltip>
                        <Tooltip title="Edit document">
                          <EditFilled 
                            onClick={() => setEditDocument(true)}
                            style={{ fontSize: "18px", cursor: "pointer" }}
                          />
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
              {(data?.documentType?.name === "VISA" || data?.documentType?.name === "Driver Licence" || data?.documentType?.name === "Proof of Age/Photo Card") && (
                <Row style={{ marginTop: "16px" }}>
                  <Col xs={18}>
                    {editBackDocument || documentBackDeleted || !data?.documentBack ? (
                      <Upload {...props} onChange={(e) => handleBackUpload(e)}>
                        <Button icon={<UploadOutlined />}>Upload {documentBackDeleted ? "New " : ""}Back Document</Button>
                      </Upload>
                    ) : (
                      <DocumentBox date={data?.createdAt} url={data?.documentBack} />
                    )}
                    {documentBackDeleted && (
                      <div style={{ padding: "10px 0", color: "#ff4d4f", fontSize: "12px" }}>
                        <p>Previous back document will be deleted. Upload a new document or click Update to confirm deletion.</p>
                      </div>
                    )}
                  </Col>
                  <Col className="editResume" xs={6}>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                      {!editBackDocument && !documentBackDeleted && data?.documentBack && (
                        <>
                          <Tooltip title="Delete back document">
                            <DeleteOutlined 
                              onClick={handleDeleteBackDocument}
                              style={{ 
                                color: "#ff4d4f", 
                                fontSize: "18px", 
                                cursor: "pointer" 
                              }}
                            />
                          </Tooltip>
                          <Tooltip title="Edit back document">
                            <EditFilled 
                              onClick={() => setEditBackDocument(true)}
                              style={{ fontSize: "18px", cursor: "pointer" }}
                            />
                          </Tooltip>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
              <Row gutter={24}>
                <Col xs={12}>
                  {data?.documentType?.name === "VISA" && (
                    <Form.Item 
                      name="visaTypeNo" 
                      label="Visa Type No"
                      rules={[
                        {
                          required: true,
                          message: "Please select visa type",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {visaTypeData?.map((e, key) => {
                          return (
                            <Select.Option key={key} value={e?.id}>
                              {e?.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  )}
                  {data?.documentType?.name === "Passport" && (
                    <Form.Item 
                      name="passportNumber" 
                      label="Passport Number"
                      rules={[
                        {
                          required: true,
                          message: "Please enter passport number",
                        },
                      ]}
                    >
                      <Input placeholder="Passport number" />
                    </Form.Item>
                  )}
                  {data?.documentType?.name === "Driver Licence" && (
                    <Form.Item 
                      name="licenseNumber" 
                      label="Licence Number"
                      rules={[
                        {
                          required: true,
                          message: "Please enter licence number",
                        },
                      ]}
                    >
                      <Input placeholder="Licence number" />
                    </Form.Item>
                  )}
                  {data?.documentType?.name === "Proof of Age/Photo Card" && (
                    <Form.Item 
                      name="idNumber" 
                      label="ID Number"
                      rules={[
                        {
                          required: true,
                          message: "Please enter ID number",
                        },
                      ]}
                    >
                      <Input placeholder="Id number" />
                    </Form.Item>
                  )}
                </Col>
                <Col xs={12}>
                  {data?.documentType?.name === "VISA" ? (
                    <Form.Item 
                      name="grantNo" 
                      label="Grant No"
                      rules={[
                        {
                          required: true,
                          message: "Please enter grant number",
                        },
                      ]}
                    >
                      <Input placeholder="Grant No" />
                    </Form.Item>
                  ) : data?.documentType?.name === "Passport" ? (
                    <Form.Item 
                      name="nationality" 
                      label="Nationality"
                      rules={[
                        {
                          required: true,
                          message: "Please select nationality",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select Nationality"
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {countries?.map((e, key) => {
                          return (
                            <Select.Option key={key} value={e.name}>
                              {e.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  ) : data?.documentType?.name === "Driver Licence" ? (
                    <Form.Item 
                      name="stateDL" 
                      label="State"
                      rules={[
                        {
                          required: true,
                          message: "Please select state",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {stateTags?.map((e, key) => {
                          return (
                            <Select.Option key={key} value={e?.name}>
                              {e?.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  ) : (
                    <Form.Item 
                      name="state" 
                      label="State"
                      rules={[
                        {
                          required: true,
                          message: "Please select state",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {stateTags?.map((e, key) => {
                          return (
                            <Select.Option key={key} value={e?.name}>
                              {e?.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  )}
                </Col>
              </Row>
              {console.log(data,"DATTA")}
              {data?.documentType?.name === "Driver Licence" && (
                <Row gutter={24}>
                  <Col xs={12}>
                    <Form.Item 
                      name="class" 
                      label="Class*"
                      requiredMark={false}
                      rules={[
                        {
                          required: true,
                          message: "Please select at least one class",
                        },
                      ]}
                    >
                      <Select
                        className=""
                        mode="multiple"
                        maxTagCount="responsive"
                        placeholder="Class"
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {classData?.map((e, key) => {
                          return (
                            <Select.Option key={key} value={e?.name}>
                              {e?.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="conditions" label="Conditions">
                      <Select
                        className=""
                        placeholder="Conditions"
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {conditions?.map((e, key) => {
                          return (
                            <Select.Option key={key} value={e?.name}>
                              {e?.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={24}>
                {data.documentType.name === "VISA" && (
                  <Col xs={12}>
                    <Form.Item 
                      label="Issue Date" 
                      name="issueDate"
                      dependencies={['expiryDate']}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const expiryDate = getFieldValue('expiryDate');
                            if (!value && !expiryDate) {
                              return Promise.reject(new Error('Please select at least issue date or expiry date'));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        className="w-100"
                        format={"DD-MM-YYYY"}
                        placeholder="Select issue date"
                      />
                    </Form.Item>
                  </Col>
                )}
                {console.log(data,"TESTDATAA")}
                {data.documentType.name === "VISA" ? (
                  <Col xs={12}>
                    <Form.Item 
                      label="Expiry" 
                      name="expiryDate"
                      dependencies={['issueDate']}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const issueDate = getFieldValue('issueDate');
                            if (!value && !issueDate) {
                              return Promise.reject(new Error('Please select at least issue date or expiry date'));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        className="w-100"
                        format={"DD-MM-YYYY"}
                        placeholder="Select expiry date"
                        // style={{ height: "38px" }}
                        // onChange={(e, date) => {setStartDate(e,date)}}
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  <Col xs={12}>
                    <Form.Item 
                      label="Expiry" 
                      name="expiryDate"
                      rules={[
                        {
                          required: true,
                          message: "Please select expiry date",
                        },
                      ]}
                    >
                      <DatePicker
                        className="w-100"
                        format={"DD-MM-YYYY"}
                        placeholder="Select expiry date"
                        // style={{ height: "38px" }}
                        // onChange={(e, date) => {setStartDate(e,date)}}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={24} className="buttonCol">
              <Button className="btn1" htmlType="submit">
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
export default OtherDetailEdit;
